import axiosInstance from "../instance";

// Get All Categories
const fetchCodes = async () => {
    const response = await axiosInstance.get('/codes');
    return response.data;
}

const addCode = async (newCode) => {
    console.log('Add COde');
    console.log(newCode);
    const response = await axiosInstance.post('/code', newCode);
    return response.data;
}

const updateCode = async (newCode) => {
    console.log('Updating Code');
    console.log(newCode);
    const response = await axiosInstance.put('/code', newCode);
    return response.data;
}

const deleteCode = async (codeId) => {
    console.log('delet category');
    console.log(codeId);

    const response = await axiosInstance.delete('/code', { params: { codeId } });
}

export { fetchCodes, addCode, updateCode, deleteCode };